import { Image, ImageViewer } from 'tdesign-react';

/**
 * 获取预览图片dom
 * @param url 图片地址 string | string[]
 * @param width 预览图宽
 * @param height 预览高
 * @param radius 圆角大小
 * @returns
 */
function getPreviewImage(url: string | string[], width = 140, height = 90, radius = '4px') {
  const images = typeof url === 'string' ? [url] : url;
  const trigger = ({ open }: any) => {
    const mask = (
      <div
        onClick={open}
        style={{
          background: 'rgba(0,0,0,.6)',
          color: '#fff',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        预览
      </div>
    );
    return (
      <Image
        style={{ borderRadius: radius, maxWidth: width, height }}
        fit="scale-down"
        src={images[0]}
        overlayTrigger="hover"
        overlayContent={mask}
      />
    );
  };
  return <ImageViewer trigger={trigger} images={images} />;
}

export { getPreviewImage };
